import React from 'react';
import { useMutation } from '@apollo/client';
import SalePaymentSaveMutation from './SalePaymentSaveMutation';
import { SavePaymentArguments } from './types';
interface ISalePaymentSaveConnectorApollo {
  children: ({
    savePayment,
    loading,
  }: {
    savePayment: (args: SavePaymentArguments) => Promise<unknown>;
    loading: boolean;
  }) => React.ReactElement;
}

const SalePaymentSaveConnectorApollo: React.FC<ISalePaymentSaveConnectorApollo> = ({
  children,
}) => {
  const [savePayment, { loading }] = useMutation(SalePaymentSaveMutation);

  const createSavePayment = async (args: SavePaymentArguments) => {
    const response = await savePayment({
      variables: {
        products: [{ id: args.productId, amount: 1, lastSource: args.source }],
        firstSource: args.source,
        promoCode: args.promoCode,
        saleShippingId: args.saleShoppingId,
        token: args.shoppingCartToken,
        ...args.deliveryAddress,
        email: args.email,
      },
    });

    return response;
  };

  return children({ savePayment: createSavePayment, loading: loading });
};

export default SalePaymentSaveConnectorApollo;
